import {
  ApplicationPaths,
  QueryParameterNames,
} from "../components/api-authorization/ApiAuthorizationConstants";
import React, { Component } from "react";

import Navbar from "./Layout/Navbar";
import { Navigate, Outlet } from "react-router-dom";
import SideBar from "./Layout/SideBar";
import authService from "../components/api-authorization/AuthorizeService";
import { trackPromise } from "react-promise-tracker";
import * as Constants from '../utils/Constants';

//import { getClientList } from "redux/actions/index";
//import { connect } from "react-redux";

export class Layout extends Component {
  static displayName = Layout.name;
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      authenticated: false,
      sidebarIsActive: true,
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() =>
      this.authenticationChanged()
    );
    this.populateAuthenticationState();
    this.SetToken();
    this.getLocalStorage();
  }

  getLocalStorage() {
    let sidebarIsActive = localStorage.getItem(Constants.LocalStorageKeys.isLeftMenuOpened);
    if (sidebarIsActive) {
      sidebarIsActive = sidebarIsActive.toLowerCase() === "true";
    } else {
      sidebarIsActive = true;
    }
    this.setState({ sidebarIsActive });
  }

  async SetToken() {
    await authService.getAccessToken();
  }

  async populateAuthenticationState() {
    const authenticated = await authService.isAuthenticated();
    this.setState({ ready: true, authenticated });
    return authenticated;
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false });
    trackPromise(
      this.populateAuthenticationState().then(() => {
        trackPromise(this.SetToken());
      })
    );
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  handleSidebarToggle = (isNavlink) => {
    let leftMenuIsOpened = true;
    if (isNavlink) {
      leftMenuIsOpened = true;
      this.setState({ sidebarIsActive: leftMenuIsOpened });
    } else {
      leftMenuIsOpened = !this.state.sidebarIsActive
      this.setState({ sidebarIsActive: leftMenuIsOpened });
    }
    localStorage.setItem(Constants.LocalStorageKeys.isLeftMenuOpened, leftMenuIsOpened);
  };

  render() {
    const { ready, authenticated } = this.state;
    const returnUrl = window.location.href;
    const redirectUrl = `${ApplicationPaths.Login}?${
      QueryParameterNames.ReturnUrl
    }=${encodeURIComponent(returnUrl)}`;

    if (!ready) {
      return (
        <div></div>
      );
    } else {
      if (authenticated) {
        return (
          <>
            <div
              className={`main-content-wrap ${
                this.state.sidebarIsActive ? "" : "nav-closed"
              }`}
            >
              <Navbar />
              <SideBar
                onSidebarToggle={this.handleSidebarToggle}
                sidebarIsActive={this.state.sidebarIsActive}
              />
              <div className="body-container">
                <Outlet />
              </div>
            </div>
            
          </>
        );
      } else {
        return <Navigate to={redirectUrl} />;
      }
    }
  }
}

// function mapStateToProps(state) {
//   return {
//   }
// }

// export default connect(mapStateToProps, {
//   getClientList
// })(Layout);
